module.exports = __webpack_public_path__ + "static/media/gruppo-maggioli.9feb7395.svg";